import { useTranslation } from "react-i18next";
import { Badge } from "./Badge";

const ActiveBadge = ({ booleanValue }) => {
  const { t } = useTranslation();

  return (
    <Badge variant={booleanValue ? "outline" : "secondary"}>
      {booleanValue ? t("defaults.activeLabel") : t("defaults.inactiveLabel")}
    </Badge>
  );
};

export default ActiveBadge;
